import { API_URL, jwtToken } from "../../../context/appContext";
export default async function deleteUser(id) {
    return fetch(`${API_URL}/api/user/${id}`, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
